import React from 'react'

import styled from 'styled-components'

const Paragraph = styled.p`
  margin: 0;
`

export const ParagraphRenderer = props => {
  return <Paragraph {...props} />
}

export const renderers = {
  Paragraph: ParagraphRenderer,
}
